import React, { useCallback } from "react";
import { Box, StretchingAsset, AssetType } from "@thenounproject/lingo-core";
import { CanvasComponentProps } from "./sharedProps";
import styled from "styled-components";
import { ItemPolling } from "../GalleryAssetContent/PollingWrappers";
import { getVersionedItemId } from "@src/helpers/items";
import { getCanvasLayoutProperties } from "./utils";
import { SelectionWrapper } from "./SelectionWrapper";
import { CanvasItemWrapper } from "./CanvasItemWrapper";
import { OverflowButton } from "./OverflowButton";

type Props = CanvasComponentProps;

const Wrapper = styled(Box)`
  position: relative;
  &:hover {
    .action-button {
      opacity: 1;
    }
  }
`;

const ContentWrapper = styled(Box).attrs(() => {
  return {
    overflow: "hidden",
    borderRadius: "default",
    background: "white",
  };
})`
  min-height: 120px;
`;

const CanvasSupportContent: React.FC<Props> = ({
  item,
  isSelected,
  onClick,
  onDragEnd,
  onDragStart,
  canEdit,
  draggable,
  onOverflowSelected,
  onDoubleClick: _onDoubleClick,
  index,
  containerWidth,
  ...rest
}) => {
  const { outerWidth, size } = getCanvasLayoutProperties({ item, containerWidth });
  const _onClick = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      onClick(item, e);
    },
    [onClick, item]
  );

  const overflowSelected = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onOverflowSelected(item);
    },
    [item, onOverflowSelected]
  );

  const versionedId = getVersionedItemId(item);

  if (!item.asset) {
    console.error(`Expected item ${item.id} to have asset`);
    return null;
  }

  const isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(item.asset.type);
  const imageStyles: React.CSSProperties = isImage ? { pointerEvents: "none" } : {};

  return (
    <CanvasItemWrapper
      data-full-width={outerWidth === "100%" || size === 1}
      outerWidth={outerWidth}
      index={index}
      itemId={item.id}
      {...rest}>
      <Wrapper
        draggable={draggable}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onClick={canEdit ? _onClick : null}
        id={item.id}
        data-itemid={versionedId}
        data-dragid={versionedId}
        data-shortid={item.shortId}
        {...rest}>
        <ItemPolling item={item} />
        <SelectionWrapper selected={isSelected}>
          <ContentWrapper>
            <StretchingAsset asset={item.asset} style={imageStyles} p="none" />
          </ContentWrapper>
        </SelectionWrapper>
        <OverflowButton
          dataPopupSource={`overflow-menu-${item.id}`}
          buttonStyle="secondary"
          icon="navigation.overflow"
          onClick={overflowSelected}
        />
      </Wrapper>
    </CanvasItemWrapper>
  );
};

export default CanvasSupportContent;
